import React, { useState } from "react";
import { FaAngleUp, FaDesktop } from "react-icons/fa6";
import SellerSelectImg from '../../../assets/Docs/selectType.png'
import SellerBusinessDetails from '../../../assets/Docs/sellerbusinessdetails.png'
import AttributesImg from '../../../assets/Docs/Seller_Attributes.png'
import sellerDashboard from '../../../assets/Docs/sellerDashboard.png'
import { FaAndroid, FaGlobe, FaMobileAlt, FaShoppingCart, FaUserTie } from "react-icons/fa";
import { TagComponent } from "../Tabs";


const SellerSetup = () => {

  
  const [activeTab, setActiveTab] = useState('web');
  const [activeTab1, setActiveTab1] = useState('web');
  const [activeTab2, setActiveTab2] = useState('web');
  const [activeTab3, setActiveTab3] = useState('web');
  const [activeTab4, setActiveTab4] = useState('web');



  //  const [activeTab2, setActiveTab2] = useState("web");

  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];

  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
              ? "bg-[#1a9588] text-white shadow"
              : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            } ${tab.disabled ? "opacity-50 cursor-not-allowed hover:bg-[#dbf4f1]" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );


  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">


      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaUserTie className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Seller Setup (For Accepting Orders)</h1>
      </div>


      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="pink" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>

      <hr className="my-6" />

      <div className="flex flex-col md:flex-row gap-8 scroll-smooth">
        
        <div className="md:w-1/4 lg:w-1/4 w-full p-4 sticky top-4 self-start">
          <div className="bg-[#dbf4f1] text-start p-4 rounded-lg">
            {/* fixed top-80 */}
            <ul className="space-y-2">
              <li className="font-semibold text-lg text-gray-700">Select a Section</li>
              <li className="border-t border-[#abe7e0] my-2"></li>
              <li><a href="#start-setup" className="text-gray-600 hover:underline">Start Setup</a></li>
              <li className="border-t border-[#abe7e0] my-2"></li>
              <li><a href="#seller-profile" className="text-gray-600 hover:underline">Create Your Seller Profile</a></li>
              <li className="border-t border-[#abe7e0] my-2"></li>
              <li><a href="#select-attributes" className="text-gray-600 hover:underline">Select Product Attributes</a></li>
              <li className="border-t border-[#abe7e0] my-2"></li>
              <li><a href="#reorder-attributes" className="text-gray-600 hover:underline">Reorder / Rename Product Attributes</a></li>
              <li className="border-t border-[#abe7e0] my-2"></li>
              <li><a href="#import-excel" className="text-gray-600 hover:underline">Import Excel</a></li>
              <li className="border-t border-[#abe7e0] my-2"></li>


              <li><a href="#setup-complete" className="text-gray-600 hover:underline">Setup Complete</a></li>
            </ul>
          </div>
        </div>

        { }
        <div className="md:w-3/4 lg:w-3/4 w-full p-4 text-start">

          { }
          <div id="start-setup" className="scroll-mt-20">
            <h3 className="text-2xl text-gray-500 mb-2 font-semibold">Select Option 1 - I'm a Seller</h3>
            
            <p className="text-gray-400 mb-6">
              After signing up, the first screen you see is the "Let's Get Started" screen. To start accepting orders, you need to become a 'Seller' on the Selzor platform. Click 'Start Seller Setup' to continue.
            </p>
            
            {renderTabs(activeTab, setActiveTab)}
            <div className="mt-4 p-4 border border-gray-200 rounded-lg">
              {activeTab === 'web' && (
                <img
                  src={SellerSelectImg}
                  alt="Web App View of Seller Setup"
                  className="w-full h-auto"
                />
              )}
              {activeTab === 'mobile' && (
                <img
                  src=""
                  alt="Mobile App View of Seller Setup"
                  className="w-full h-auto"
                />
              )}
            </div>
          </div>
          <div className="flex justify-end my-4">
            <a href="#top" className="text-blue-600 hover:underline">
              <FaAngleUp />
            </a>
          </div>
          <hr className="my-6" />

          { }
          <div id="seller-profile" className="scroll-mt-20">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-2xl text-gray-500 mb-2 font-semibold">Create Your Seller Profile</h3>
              <span className="bg-gray-400 text-white text-xs font-semibold px-2 py-1 rounded-lg">Step 1 of 5</span>
            </div>
            <p className="text-gray-400 mb-6">
              Create your seller profile by entering in some basic information - Primary Contact, Company Name, Company Initials, Email Address &amp; Postal Address Details.
              <br /><br />
              The email address field is very important &amp; requires verification. Information regarding New Buyer Requests &amp; New Orders will be received as an email on this address.
            </p>
            {renderTabs(activeTab1, setActiveTab1)}
            <div className="mt-4 p-4 border border-gray-200 rounded-lg">
              {activeTab1 === 'web' && (
                <img
                  src={SellerBusinessDetails}
                  alt="Web App View of Seller Profile"
                  className="w-full h-auto"
                />
              )}
              {activeTab1 === 'mobile' && (
                <img
                  src=""
                  alt="Mobile App View of Seller Profile"
                  className="w-full h-auto"
                />
              )}
            </div>
          </div>
          <div className="flex justify-end my-4">
            <a href="#top" className="text-blue-600 hover:underline">
              <FaAngleUp />
            </a>
          </div>
          <hr className="my-6" />

          { }
          <div id="select-attributes" className="scroll-mt-20">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-2xl text-gray-500 font-semibold">Select Product Attributes</h3>
              <span className="bg-gray-400 text-white text-xs font-semibold px-2 py-1 rounded-lg">Step 2 of 5</span>
            </div>
            <p className="text-gray-400 mb-6">
              Select attributes as per your product range. Code, Name &amp; Category are required attributes. You have an option to include all attributes while adding product data but only displaying a few of them to your buyers. Data for majority of these attributes can be imported by simply uploading an Excel (XLS) file.
            </p>
            {renderTabs(activeTab2, setActiveTab2)}
            <div className="mt-4 p-4 border border-gray-200 rounded-lg">
              {activeTab2 === 'web' && (
                <img
                  src={AttributesImg}
                  alt="Web App View of Product Attributes"
                  className="w-full h-auto"
                />
              )}
              {activeTab2 === 'mobile' && (
                <img
                  src=""
                  alt="Mobile App View of Product Attributes"
                  className="w-full h-auto"
                />
              )}
            </div>
            <div className="text-start py-5 mt-3">
              <div>
                <h3 className="text-gray-600 font-semibold text-lg pb-3">Related Topics</h3>
                <div className="text-sm text-gray-500">
                  <div><a href="ProductAttributes" className=" hover:underline hover:text-[#1a9588]">Product Attributes</a></div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-end my-4">
            <a href="#top" className="text-blue-600 hover:underline">
              <FaAngleUp />
            </a>
          </div>
          <hr className="my-6" />

          { }
          <div id="reorder-attributes" className="scroll-mt-20">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-2xl text-gray-500 font-semibold">Reorder / Rename Product Attributes</h3>
              <span className="bg-gray-400 text-white text-xs font-semibold px-2 py-1 rounded-lg">Step 3 of 5</span>
            </div>
            <p className="text-gray-400 mb-6">
              The attributes you selected in the previous step are listed here. You can assign a custom name to these attributes e.g. 'Price 1' can be 'MRP' or 'List Price' &amp; so on.
              <br /><br />
              If you already have your price-list in Excel format, you can reorder these attributes by dragging the column name badge and matching their order with the columns in your price-list. Or you can simply download the blank Excel template &amp; add your products.
              <br /><br />
              Take care of the maximum characters &amp; cell format. DO NOT reorder/rearrange columns in the Excel file.
            </p>
            {renderTabs(activeTab3, setActiveTab3)}
            <div className="mt-4 p-4 border border-gray-200 rounded-lg">
              {activeTab3 === 'web' && (
                <img
                  src=""
                  alt="Web App View of Reorder Attributes"
                  className="w-full h-auto"
                />
              )}
              {activeTab3 === 'mobile' && (
                <div className="text-center text-gray-500">Mobile App View is disabled for this section.</div>
              )}
            </div>
          </div>


          <div className="flex justify-end my-4">
            <a href="#top" className="text-blue-600 hover:underline">
              <FaAngleUp />
            </a>
          </div>
          <hr className="my-6" />

          { }
          <div id="import-excel" className="scroll-mt-20">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-2xl text-gray-500 font-semibold">Import Excel</h3>
              <span className="bg-gray-400 text-white text-xs font-semibold px-2 py-1 rounded-lg">Step 4 of 5</span>
            </div>
            <p className="text-gray-400 mb-6">
              Browse your Excel file &amp; Selzor displays the Excel data for your review. The unique import values for attributes like code, category, tax-tiers &amp; warehouses, is listed on the left. Errors, if any, are highlighted in red. A maximum of 1000 rows of data can be imported in one go.
            </p>
            {renderTabs(activeTab4, setActiveTab4)}
            <div className="mt-4 p-4 border border-gray-200 rounded-lg">
              {activeTab4 === 'web' && (
                <img
                  src=""
                  alt="Web App View of Import Excel"
                  className="w-full h-auto"
                />
              )}
              {activeTab4 === 'mobile' && (
                <div className="text-center text-gray-500">Mobile App View is disabled for this section.</div>
              )}
            </div>
            <div className="bg-red-50 border border-red-100 text-red-500 px-4 py-3 rounded relative my-4" role="alert">
              <p>Excel data once imported cannot be deleted. To delete or change that data you will have to do it one by one for every product.</p>
            </div>

            <div className="text-start py-5 pb-0 mt-3">
              <div>
                <h3 className="text-gray-600 font-semibold text-lg pb-3">Related Topics</h3>
                <div className="text-sm text-gray-500">
                  <div><a href="PreperingData" className=" hover:underline hover:text-[#1a9588]">Preparing Data for Import</a></div>
                  <div><a href="ExportExcelData" className=" hover:underline hover:text-[#1a9588]">Import Excel Data</a></div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-end my-4">
            <a href="#top" className="text-blue-600 hover:underline">
              <FaAngleUp />
            </a>
          </div>
          <hr className="my-6" />


          <div id="setup-complete" className="scroll-mt-20">
            <h3 className="text-2xl text-gray-500 mb-2 font-semibold">Setup Complete</h3>
            <p className="text-gray-400 mb-6">
              That's it, your Seller Setup is now complete &amp; your unique 8-digit, Selzor App Code is generated. This App Code identifies you as a 'Seller' on the Selzor platform and is the connecting link between you &amp; your wholesale customers. Share this app code with your customers and invite them to place orders to you on the Selzor platform.
            </p>
            {renderTabs(activeTab, setActiveTab)}
            <div className="mt-4 p-4 border border-gray-200 rounded-lg">
              {activeTab === 'web' && (
                <img
                  src={sellerDashboard}
                  alt="Web App View of Setup Complete"
                  className="w-full h-auto"
                />
              )}
              {activeTab === 'mobile' && (
                <img
                  src=""
                  alt="Mobile App View of Setup Complete"
                  className="w-full h-auto"
                />
              )}
            </div>

            <div className="text-start py-5 pb-0 mt-3">
              <div>
                <h3 className="text-gray-600 font-semibold text-lg pb-3">Related Topics</h3>
                <div className="text-sm text-gray-500">
                  <div><a href="AddingBuyer" className=" hover:underline hover:text-[#1a9588]">Adding / Inviting Buyers</a></div>
                  <div><a href="ShareAppCode" className=" hover:underline hover:text-[#1a9588]">Share your App Code</a></div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-end my-4">
            <a href="#top" className="text-blue-600 hover:underline">
              <FaAngleUp />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellerSetup;